import * as Yup from "yup";
import formData from "./formData";

const {
  formField: { fillByDate, vessel, assignee, rating, port, jobType },
} = formData;

const validationSchema = Yup.object().shape({
  [fillByDate.name]: Yup.string().required(
    `${fillByDate.requiredErrorMessage}`
  ),
  [vessel.name]: Yup.object()
    .nullable(true)
    .required(`${vessel.requiredErrorMessage}`),
  [assignee.name]: Yup.object()
    .nullable(true)
    .required(`${assignee.requiredErrorMessage}`),
  [port.name]: Yup.string()
    .nullable(true)
    .required(`${port.requiredErrorMessage}`)
    .test({
      name: "test",
      message: "Port must be in the selected vessel's port list",
      test: (value, context) => {
        return !!context.parent.vessel?.ports
          ? context.parent.vessel.ports.includes(value)
          : true;
      },
    }),
  [rating.name]: Yup.string()
    .nullable(true)
    .required(`${rating.requiredErrorMessage}`),
  [jobType.name]: Yup.string().required("Job Type is required"),
});

export default validationSchema;
